import { useEffect } from "react";
import { useLocation } from "react-router-dom";

export default function useCleanTrackingParams() {
  const location = useLocation();

  useEffect(() => {
    const url = new URL(window.location.href);
    let changed = false;

    // List of exact params to remove
    const exactParams = ["fbclid", "gclid"];

    // Remove exact matches
    exactParams.forEach(param => {
      if (url.searchParams.has(param)) {
        url.searchParams.delete(param);
        changed = true;
      }
    });

    // Remove anything starting with "utm_"
    [...url.searchParams.keys()].forEach(key => {
      if (key.toLowerCase().startsWith("utm_")) {
        url.searchParams.delete(key);
        changed = true;
      }
    });

    // Update URL without reloading if anything changed
    if (changed) {
      window.history.replaceState({}, document.title, url.pathname + url.hash);
    }
  }, [location]);
}